<template>
    <ui-sidepage :close="close"
                 large
                 :title="'Estimate Clipboard'"
                 :subtitle="``" :go-transparent="true"
                 :key="clipboardKey">
        <ui-form-section class="mt-1">
            <div class="col-span-5 pt-2.5 ">Currently viewing</div>
            <div class="col-span-7">
                <ui-select v-model="viewing" :options="viewables"></ui-select>
            </div>
        </ui-form-section>
        <hr>
        <estimate-clipboard-estimates v-if="viewing==='estimate'" :user="user"></estimate-clipboard-estimates>
        <estimate-clipboard-sections v-if="viewing==='section'" :user="user"></estimate-clipboard-sections>
        <estimate-clipboard-tasks v-if="viewing==='task'" :user="user"></estimate-clipboard-tasks>
        <estimate-clipboard-items v-if="viewing==='item'" :user="user"></estimate-clipboard-items>
        <estimate-clipboard-preliminary-groups v-if="viewing==='group'"
                                               :user="user"></estimate-clipboard-preliminary-groups>
        <estimate-clipboard-preliminary-items v-if="viewing==='groupitem'"
                                              :user="user"></estimate-clipboard-preliminary-items>
    </ui-sidepage>
</template>

<script>
import UiSidepage from "../../../ui/UiSidepage.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";
import UiSelect from "../../../ui/UiSelect.vue";
import EstimateClipboardEstimates from "./EstimateClipboardEstimates.vue";
import EstimateClipboardTasks from "./EstimateClipboardTasks.vue";
import EstimateClipboardSections from "./EstimateClipboardSections.vue";
import EstimateClipboardItems from "./EstimateClipboardItems.vue";
import remoteStorage from "../../../../utils/remoteStorage";
import EstimateClipboardPreliminaryGroups from "./EstimateClipboardPreliminaryGroups.vue";
import EstimateClipboardPreliminaryItems from "./EstimateClipboardPreliminaryItems.vue";

export default {
    components: {
        EstimateClipboardPreliminaryItems,
        EstimateClipboardPreliminaryGroups,
        EstimateClipboardItems,
        EstimateClipboardTasks,
        EstimateClipboardSections,
        EstimateClipboardEstimates,
        UiSelect,
        UiFormSection,
        UiSidepage
    },
    props: {
        close: Function,
        user: Object,
    },
    watch: {
        userClipboardToBeWatched: {
            handler(newValue, oldValue) {
                this.estimateClipboard = remoteStorage.getItem('estimate-clipboard-view') ? JSON.parse(remoteStorage.getItem('estimate-clipboard-view')) : [];
                this.clipboardKey++;
            },
        },
    },
    computed: {
        userClipboardToBeWatched() {
            return this.user.remoteStorage ? this.user.remoteStorage['estimate-clipboard-view']
                : '';
        },
    },
    data() {
        let defaultView = remoteStorage.getItem('estimate-clipboard-view')

        return {
            viewing: defaultView ? defaultView : 'item',
            viewables: [
                {value: 'estimate', label: 'Estimates'},
                {value: 'section', label: 'Sections'},
                {value: 'task', label: 'Tasks'},
                {value: 'item', label: 'Items'},
                {value: 'group', label: 'Preliminary Groups'},
                {value: 'groupitem', label: 'Preliminary Items'},
            ],
            clipboardKey: 0,
        }
    },

    async mounted() {

    },
    methods: {}
}
</script>
